import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import HomeView from '../views/HomeView.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '/HomeView',
    component: HomeView,
    redirect: "/index",
    meta: {
      title: '首页'
    },
    children: [
      {
        path: "/index",
        name: "home",
        component: () => import("../views/home/index.vue"),
      },
    ],
  },
]

// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })
// const router = new VueRouter({
//   base: '/wy/abjg/',
//   mode:'history',
//   routes,
// });
const router = new VueRouter({
  
  routes,
});

export default router
